/*　【リリース時の手順】
 * 1. 新しいバージョンのインストーラ名、URLの定数定義を追加する
 * 2. [ソフト名] latestの定義箇所に、ダウンロード画面に表示するバージョンの定数定義を入れる
 * 3. マニュアルの更新があれば、ファイル名等を修正する
 * 4. 過去のリリース情報ページの更新を行う
 */

/************************************/
/* DF Scanner Pro v1.9.2 */
export const DF_SCANNER_PRO_FILENAME_V1_9_2 = "Setup DF Scanner Pro 1.9.2.exe";
export const DF_SCANNER_PRO_URL_V1_9_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.9.2.exe";

/* DF Scanner Pro v1.9.1 */
export const DF_SCANNER_PRO_FILENAME_V1_9_1 = "Setup DF Scanner Pro 1.9.1.exe";
export const DF_SCANNER_PRO_URL_V1_9_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.9.1.exe";

/* DF Scanner Pro v1.9.0 */
export const DF_SCANNER_PRO_FILENAME_V1_9_0 = "Setup DF Scanner Pro 1.9.0.exe";
export const DF_SCANNER_PRO_URL_V1_9_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.9.0.exe";

/* DF Scanner Lite v1.9.0 */
export const DF_SCANNER_LITE_FILENAME_V1_9_0 = "Setup DF Scanner Lite 1.9.0.exe";
export const DF_SCANNER_LITE_URL_V1_9_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.9.0.exe";

/* DF Scanner Pro v1.8.1 */
export const DF_SCANNER_PRO_FILENAME_V1_8_1 = "Setup DF Scanner Pro 1.8.1.exe";
export const DF_SCANNER_PRO_URL_V1_8_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.8.1.exe";

/* DF Scanner Lite v1.8.1 */
export const DF_SCANNER_LITE_FILENAME_V1_8_1 = "Setup DF Scanner Lite 1.8.1.exe";
export const DF_SCANNER_LITE_URL_V1_8_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.8.1.exe";

/* DF Scanner Pro v1.8.0 */
export const DF_SCANNER_PRO_FILENAME_V1_8_0 = "Setup DF Scanner Pro 1.8.0.exe";
export const DF_SCANNER_PRO_URL_V1_8_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.8.0.exe";

/* DF Scanner Lite v1.8.0 */
export const DF_SCANNER_LITE_FILENAME_V1_8_0 = "Setup DF Scanner Lite 1.8.0.exe";
export const DF_SCANNER_LITE_URL_V1_8_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.8.0.exe";

/* DF Scanner Pro v1.7.1 */
export const DF_SCANNER_PRO_FILENAME_V1_7_1 = "Setup DF Scanner Pro 1.7.1.exe";
export const DF_SCANNER_PRO_URL_V1_7_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.7.1.exe";

/* DF Scanner Lite v1.7.1 */
export const DF_SCANNER_LITE_FILENAME_V1_7_1 = "Setup DF Scanner Lite 1.7.1.exe";
export const DF_SCANNER_LITE_URL_V1_7_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.7.1.exe";

/* DF Scanner Pro v1.7.0 */
export const DF_SCANNER_PRO_FILENAME_V1_7_0 = "Setup DF Scanner Pro 1.7.0.exe";
export const DF_SCANNER_PRO_URL_V1_7_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.7.0.exe";

/* DF Scanner Lite v1.7.0 */
export const DF_SCANNER_LITE_FILENAME_V1_7_0 = "Setup DF Scanner Lite 1.7.0.exe";
export const DF_SCANNER_LITE_URL_V1_7_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.7.0.exe";

/* DF Scanner Pro v1.6.4 */
export const DF_SCANNER_PRO_FILENAME_V1_6_4 = "Setup DF Scanner Pro 1.6.4.exe";
export const DF_SCANNER_PRO_URL_V1_6_4 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.6.4.exe";

/* DF Scanner Lite v1.6.4 */
export const DF_SCANNER_LITE_FILENAME_V1_6_4 = "Setup DF Scanner Lite 1.6.4.exe";
export const DF_SCANNER_LITE_URL_V1_6_4 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.6.4.exe";

/* DF Scanner Pro v1.6.3 */
export const DF_SCANNER_PRO_FILENAME_V1_6_3 = "Setup DF Scanner Pro 1.6.3.exe";
export const DF_SCANNER_PRO_URL_V1_6_3 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.6.3.exe";

/* DF Scanner Lite v1.6.3 */
export const DF_SCANNER_LITE_FILENAME_V1_6_3 = "Setup DF Scanner Lite 1.6.3.exe";
export const DF_SCANNER_LITE_URL_V1_6_3 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.6.3.exe";

/* DF Scanner Pro v1.6.2 */
export const DF_SCANNER_PRO_FILENAME_V1_6_2 = "Setup DF Scanner Pro 1.6.2.exe";
export const DF_SCANNER_PRO_URL_V1_6_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.6.2.exe";

/* DF Scanner Lite v1.6.2 */
export const DF_SCANNER_LITE_FILENAME_V1_6_2 = "Setup DF Scanner Lite 1.6.2.exe";
export const DF_SCANNER_LITE_URL_V1_6_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.6.2.exe";

/* DF Scanner Pro v1.6.1 */
export const DF_SCANNER_PRO_FILENAME_V1_6_1 = "Setup DF Scanner Pro 1.6.1.exe";
export const DF_SCANNER_PRO_URL_V1_6_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.6.1.exe";

/* DF Scanner Lite v1.6.1 */
export const DF_SCANNER_LITE_FILENAME_V1_6_1 = "Setup DF Scanner Lite 1.6.1.exe";
export const DF_SCANNER_LITE_URL_V1_6_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.6.1.exe";

/* DF Scanner Pro v1.6.0 */
export const DF_SCANNER_PRO_FILENAME_V1_6_0 = "Setup DF Scanner Pro 1.6.0.exe";
export const DF_SCANNER_PRO_URL_V1_6_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.6.0.exe";

/* DF Scanner Lite v1.6.0 */
export const DF_SCANNER_LITE_FILENAME_V1_6_0 = "Setup DF Scanner Lite 1.6.0.exe";
export const DF_SCANNER_LITE_URL_V1_6_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.6.0.exe";

/* DF Scanner Pro v1.5.2 */
export const DF_SCANNER_PRO_FILENAME_V1_5_2 = "Setup DF Scanner Pro 1.5.2.exe";
export const DF_SCANNER_PRO_URL_V1_5_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.5.2.exe";

/* DF Scanner Lite v1.5.2 */
export const DF_SCANNER_LITE_FILENAME_V1_5_2 = "Setup DF Scanner Lite 1.5.2.exe";
export const DF_SCANNER_LITE_URL_V1_5_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.5.2.exe";

/* DF Scanner Pro v1.5.1 */
export const DF_SCANNER_PRO_FILENAME_V1_5_1 = "Setup DF Scanner Pro 1.5.1.exe";
export const DF_SCANNER_PRO_URL_V1_5_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.5.1.exe";

/* DF Scanner Lite v1.5.1 */
export const DF_SCANNER_LITE_FILENAME_V1_5_1 = "Setup DF Scanner Lite 1.5.1.exe";
export const DF_SCANNER_LITE_URL_V1_5_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.5.1.exe";

/* DF Scanner Pro v1.5.0 */
export const DF_SCANNER_PRO_FILENAME_V1_5_0 = "Setup DF Scanner Pro 1.5.0.exe";
export const DF_SCANNER_PRO_URL_V1_5_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.5.0.exe";

/* DF Scanner Lite v1.5.0 */
export const DF_SCANNER_LITE_FILENAME_V1_5_0 = "Setup DF Scanner Lite 1.5.0.exe";
export const DF_SCANNER_LITE_URL_V1_5_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.5.0.exe";

/* DF Scanner Pro v1.4.1 */
export const DF_SCANNER_PRO_FILENAME_V1_4_1 = "Setup DF Scanner Pro 1.4.1.exe";
export const DF_SCANNER_PRO_URL_V1_4_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.4.1.exe";

/* DF Scanner Lite v1.4.1 */
export const DF_SCANNER_LITE_FILENAME_V1_4_1 = "Setup DF Scanner Lite 1.4.1.exe";
export const DF_SCANNER_LITE_URL_V1_4_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.4.1.exe";

/* DF Scanner Pro v1.4.0 */
export const DF_SCANNER_PRO_FILENAME_V1_4_0 = "Setup DF Scanner Pro 1.4.0.exe";
export const DF_SCANNER_PRO_URL_V1_4_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.4.0.exe";

/* DF Scanner Lite v1.4.0 */
export const DF_SCANNER_LITE_FILENAME_V1_4_0 = "Setup DF Scanner Lite 1.4.0.exe";
export const DF_SCANNER_LITE_URL_V1_4_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.4.0.exe";

/* DF Scanner Pro v1.3.2 */
export const DF_SCANNER_PRO_FILENAME_V1_3_2 = "Setup DF Scanner Pro 1.3.2.exe";
export const DF_SCANNER_PRO_URL_V1_3_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.3.2.exe";

/* DF Scanner Lite v1.3.2 */
export const DF_SCANNER_LITE_FILENAME_V1_3_2 = "Setup DF Scanner Lite 1.3.2.exe";
export const DF_SCANNER_LITE_URL_V1_3_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.3.2.exe";

/* DF Scanner v1.8.2 */
export const DF_SCANNER_FILENAME_V1_8_2 = "Setup DF Scanner 1.8.2.exe";
export const DF_SCANNER_URL_V1_8_2 = "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%201.8.2.exe";

/* DF Scanner Pro v1.3.1 */
export const DF_SCANNER_PRO_FILENAME_V1_3_1 = "Setup DF Scanner Pro 1.3.1.exe";
export const DF_SCANNER_PRO_URL_V1_3_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.3.1.exe";

/* DF Scanner Lite v1.3.1 */
export const DF_SCANNER_LITE_FILENAME_V1_3_1 = "Setup DF Scanner Lite 1.3.1.exe";
export const DF_SCANNER_LITE_URL_V1_3_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.3.1.exe";

/* DF Scanner v1.8.1 */
export const DF_SCANNER_FILENAME_V1_8_1 = "Setup DF Scanner 1.8.1.exe";
export const DF_SCANNER_URL_V1_8_1 = "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%201.8.1.exe";

/* DF Scanner Pro v1.3.0 */
export const DF_SCANNER_PRO_FILENAME_V1_3_0 = "Setup DF Scanner Pro 1.3.0.exe";
export const DF_SCANNER_PRO_URL_V1_3_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.3.0.exe";

/* DF Scanner Lite v1.3.0 */
export const DF_SCANNER_LITE_FILENAME_V1_3_0 = "Setup DF Scanner Lite 1.3.0.exe";
export const DF_SCANNER_LITE_URL_V1_3_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.3.0.exe";

/* DF Scanner v1.8.0 */
export const DF_SCANNER_FILENAME_V1_8_0 = "Setup DF Scanner 1.8.0.exe";
export const DF_SCANNER_URL_V1_8_0 = "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%201.8.0.exe";

/* DF Scanner Pro v1.2.1 */
export const DF_SCANNER_PRO_FILENAME_V1_2_1 = "Setup DF Scanner Pro 1.2.1.exe";
export const DF_SCANNER_PRO_URL_V1_2_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.2.1.exe";

/* DF Scanner Lite v1.2.1 */
export const DF_SCANNER_LITE_FILENAME_V1_2_1 = "Setup DF Scanner Lite 1.2.1.exe";
export const DF_SCANNER_LITE_URL_V1_2_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.2.1.exe";

/* DF Scanner v1.7.1 */
export const DF_SCANNER_FILENAME_V1_7_1 = "Setup DF Scanner 1.7.1.exe";
export const DF_SCANNER_URL_V1_7_1 = "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%201.7.1.exe";

/* DF Scanner Pro v1.2.0 */
export const DF_SCANNER_PRO_FILENAME_V1_2_0 = "Setup DF Scanner Pro 1.2.0.exe";
export const DF_SCANNER_PRO_URL_V1_2_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Pro%201.2.0.exe";

/* DF Scanner Lite v1.2.0 */
export const DF_SCANNER_LITE_FILENAME_V1_2_0 = "Setup DF Scanner Lite 1.2.0.exe";
export const DF_SCANNER_LITE_URL_V1_2_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%20Lite%201.2.0.exe";

/* DF Scanner v1.7.0 */
export const DF_SCANNER_FILENAME_V1_7_0 = "Setup DF Scanner 1.7.0.exe";
export const DF_SCANNER_URL_V1_7_0 = "https://deepforestlicense.com/DFScanner/Setup%20DF%20Scanner%201.7.0.exe";

/* DF Scanner Pro v1.1.1 */
export const DF_SCANNER_PRO_GPU_FILENAME_V1_1_1 = "Setup cuda11 DF Scanner Pro 1.1.1.exe";
export const DF_SCANNER_PRO_GPU_URL_V1_1_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%20Pro%201.1.1.exe";
export const DF_SCANNER_PRO_CPU_FILENAME_V1_1_1 = "Setup cpu DF Scanner Pro 1.1.1.exe";
export const DF_SCANNER_PRO_CPU_URL_V1_1_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%20Pro%201.1.1.exe";

/* DF Scanner Lite v1.1.1 */
export const DF_SCANNER_LITE_GPU_FILENAME_V1_1_1 = "Setup cuda11 DF Scanner Lite 1.1.1.exe";
export const DF_SCANNER_LITE_GPU_URL_V1_1_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%20Lite%201.1.1.exe";
export const DF_SCANNER_LITE_CPU_FILENAME_V1_1_1 = "Setup cpu DF Scanner Lite 1.1.1.exe";
export const DF_SCANNER_LITE_CPU_URL_V1_1_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%20Lite%201.1.1.exe";

/* DF Scanner v1.6.1 */
export const DF_SCANNER_GPU_FILENAME_V1_6_1 = "Setup cuda11 DF Scanner 1.6.1.exe";
export const DF_SCANNER_GPU_URL_V1_6_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%201.6.1.exe";
export const DF_SCANNER_CPU_FILENAME_V1_6_1 = "Setup cpu DF Scanner 1.6.1.exe";
export const DF_SCANNER_CPU_URL_V1_6_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%201.6.1.exe";

/* DF Scanner Pro v1.1.0 */
export const DF_SCANNER_PRO_GPU_FILENAME_V1_1_0 = "Setup cuda11 DF Scanner Pro 1.1.0.exe";
export const DF_SCANNER_PRO_GPU_URL_V1_1_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%20Pro%201.1.0.exe";
export const DF_SCANNER_PRO_CPU_FILENAME_V1_1_0 = "Setup cpu DF Scanner Pro 1.1.0.exe";
export const DF_SCANNER_PRO_CPU_URL_V1_1_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%20Pro%201.1.0.exe";

/* DF Scanner Lite v1.1.0 */
export const DF_SCANNER_LITE_GPU_FILENAME_V1_1_0 = "Setup cuda11 DF Scanner Lite 1.1.0.exe";
export const DF_SCANNER_LITE_GPU_URL_V1_1_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%20Lite%201.1.0.exe";
export const DF_SCANNER_LITE_CPU_FILENAME_V1_1_0 = "Setup cpu DF Scanner Lite 1.1.0.exe";
export const DF_SCANNER_LITE_CPU_URL_V1_1_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%20Lite%201.1.0.exe";

/* DF Scanner v1.6.0 */
export const DF_SCANNER_GPU_FILENAME_V1_6_0 = "Setup cuda11 DF Scanner 1.6.0.exe";
export const DF_SCANNER_GPU_URL_V1_6_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%201.6.0.exe";
export const DF_SCANNER_CPU_FILENAME_V1_6_0 = "Setup cpu DF Scanner 1.6.0.exe";
export const DF_SCANNER_CPU_URL_V1_6_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%201.6.0.exe";

/* DF Scanner Pro v1.0.2 */
export const DF_SCANNER_PRO_GPU_FILENAME_V1_0_2 = "Setup cuda11 DF Scanner Pro 1.0.2.exe";
export const DF_SCANNER_PRO_GPU_URL_V1_0_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%20Pro%201.0.2.exe";
export const DF_SCANNER_PRO_CPU_FILENAME_V1_0_2 = "Setup cpu DF Scanner Pro 1.0.2.exe";
export const DF_SCANNER_PRO_CPU_URL_V1_0_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%20Pro%201.0.2.exe";

/* DF Scanner Lite v1.0.2 */
export const DF_SCANNER_LITE_GPU_FILENAME_V1_0_2 = "Setup cuda11 DF Scanner Lite 1.0.2.exe";
export const DF_SCANNER_LITE_GPU_URL_V1_0_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%20Lite%201.0.2.exe";
export const DF_SCANNER_LITE_CPU_FILENAME_V1_0_2 = "Setup cpu DF Scanner Lite 1.0.2.exe";
export const DF_SCANNER_LITE_CPU_URL_V1_0_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%20Lite%201.0.2.exe";

/* DF Scanner v1.5.2 */
export const DF_SCANNER_GPU_FILENAME_V1_5_2 = "Setup cuda11 DF Scanner 1.5.2.exe";
export const DF_SCANNER_GPU_URL_V1_5_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%201.5.2.exe";
export const DF_SCANNER_CPU_FILENAME_V1_5_2 = "Setup cpu DF Scanner 1.5.2.exe";
export const DF_SCANNER_CPU_URL_V1_5_2 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%201.5.2.exe";

/* DF Scanner Pro v1.0.1 */
export const DF_SCANNER_PRO_GPU_FILENAME_V1_0_1 = "Setup cuda11 DF Scanner Pro 1.0.1.exe";
export const DF_SCANNER_PRO_GPU_URL_V1_0_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%20Pro%201.0.1.exe";
export const DF_SCANNER_PRO_CPU_FILENAME_V1_0_1 = "Setup cpu DF Scanner Pro 1.0.1.exe";
export const DF_SCANNER_PRO_CPU_URL_V1_0_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%20Pro%201.0.1.exe";

/* DF Scanner Lite v1.0.1 */
export const DF_SCANNER_LITE_GPU_FILENAME_V1_0_1 = "Setup cuda11 DF Scanner Lite 1.0.1.exe";
export const DF_SCANNER_LITE_GPU_URL_V1_0_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%20Lite%201.0.1.exe";
export const DF_SCANNER_LITE_CPU_FILENAME_V1_0_1 = "Setup cpu DF Scanner Lite 1.0.1.exe";
export const DF_SCANNER_LITE_CPU_URL_V1_0_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%20Lite%201.0.1.exe";

/* DF Scanner v1.5.1 */
export const DF_SCANNER_GPU_FILENAME_V1_5_1 = "Setup cuda11 DF Scanner 1.5.1.exe";
export const DF_SCANNER_GPU_URL_V1_5_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%201.5.1.exe";
export const DF_SCANNER_CPU_FILENAME_V1_5_1 = "Setup cpu DF Scanner 1.5.1.exe";
export const DF_SCANNER_CPU_URL_V1_5_1 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%201.5.1.exe";

/* DF Scanner Pro v1.0.0 */
export const DF_SCANNER_PRO_GPU_FILENAME_V1_0_0 = "Setup cuda11 DF Scanner Pro 1.0.0.exe";
export const DF_SCANNER_PRO_GPU_URL_V1_0_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%20Pro%201.0.0.exe";
export const DF_SCANNER_PRO_CPU_FILENAME_V1_0_0 = "Setup cpu DF Scanner Pro 1.0.0.exe";
export const DF_SCANNER_PRO_CPU_URL_V1_0_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%20Pro%201.0.0.exe";

/* DF Scanner Lite v1.0.0 */
export const DF_SCANNER_LITE_GPU_FILENAME_V1_0_0 = "Setup cuda11 DF Scanner Lite 1.0.0.exe";
export const DF_SCANNER_LITE_GPU_URL_V1_0_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%20Lite%201.0.0.exe";
export const DF_SCANNER_LITE_CPU_FILENAME_V1_0_0 = "Setup cpu DF Scanner Lite 1.0.0.exe";
export const DF_SCANNER_LITE_CPU_URL_V1_0_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%20Lite%201.0.0.exe";

/* DF Scanner v1.5.0 */
export const DF_SCANNER_GPU_FILENAME_V1_5_0 = "Setup cuda11 DF Scanner 1.5.0.exe";
export const DF_SCANNER_GPU_URL_V1_5_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20cuda11%20DF%20Scanner%201.5.0.exe";
export const DF_SCANNER_CPU_FILENAME_V1_5_0 = "Setup cpu DF Scanner 1.5.0.exe";
export const DF_SCANNER_CPU_URL_V1_5_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20cpu%20DF%20Scanner%201.5.0.exe";

/************************************/
/* AI樹冠分離モデル v1.0 */
export const AI_SEGMENTATION_MODEL_FILENAME_V1_0 = "Setup AI Segmentation Model 1.0.exe";
export const AI_SEGMENTATION_MODEL_URL_V1_0 =
    "https://deepforestlicense.com/DFScanner/Setup%20AI%20Segmentation%20Model%201.0.exe";

/************************************/
/* DF Viewer v1.0.0 */
export const DF_VIEWER_FILENAME_V1_0_0 = "Setup DF Viewer 1.0.0.exe";
export const DF_VIEWER_URL_V1_0_0 = "https://deepforestlicense.com/DFViewer/Setup%20DF%20Viewer%201.0.0.exe";

/* DF Viewer v1.1.0 */
export const DF_VIEWER_FILENAME_V1_1_0 = "Setup DF Viewer 1.1.0.exe";
export const DF_VIEWER_URL_V1_1_0 = "https://deepforestlicense.com/DFViewer/Setup%20DF%20Viewer%201.1.0.exe";

/* DF Viewer v1.2.0 */
export const DF_VIEWER_FILENAME_V1_2_0 = "Setup DF Viewer 1.2.0.exe";
export const DF_VIEWER_URL_V1_2_0 = "https://deepforestlicense.com/DFViewer/Setup%20DF%20Viewer%201.2.0.exe";

/* DF Viewer v1.3.0 */
export const DF_VIEWER_FILENAME_V1_3_0 = "Setup DF Viewer 1.3.0.exe";
export const DF_VIEWER_URL_V1_3_0 = "https://deepforestlicense.com/DFViewer/Setup%20DF%20Viewer%201.3.0.exe";

/* DF Viewer v1.4.0 */
export const DF_VIEWER_FILENAME_V1_4_0 = "Setup DF Viewer 1.4.0.exe";
export const DF_VIEWER_URL_V1_4_0 = "https://deepforestlicense.com/DFViewer/Setup%20DF%20Viewer%201.4.0.exe";

/* DF Viewer v1.4.1 */
export const DF_VIEWER_FILENAME_V1_4_1 = "Setup DF Viewer 1.4.1.exe";
export const DF_VIEWER_URL_V1_4_1 = "https://deepforestlicense.com/DFViewer/Setup%20DF%20Viewer%201.4.1.exe";

/************************************/
/* DF LAT Pro v2.0.0 */
export const DF_LAT_PRO_FILENAME_V2_0_0 = "Setup DF LAT Pro 2.0.0.exe";
export const DF_LAT_PRO_V2_0_0 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Pro%202.0.0.exe";

/* DF LAT Lite v2.0.0 */
export const DF_LAT_LITE_FILENAME_V2_0_0 = "Setup DF LAT Lite 2.0.0.exe";
export const DF_LAT_LITE_V2_0_0 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Lite%202.0.0.exe";

/* DF LAT Lite v1.3.4 */
export const DF_LAT_LITE_FILENAME_V1_3_4 = "Setup DF LAT Lite 1.3.4.exe";
export const DF_LAT_LITE_V1_3_4 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Lite%201.3.4.exe";

/* DF LAT Pro v1.3.3 */
export const DF_LAT_PRO_FILENAME_V1_3_3 = "Setup DF LAT Pro 1.3.3.exe";
export const DF_LAT_PRO_V1_3_3 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Pro%201.3.3.exe";

/* DF LAT Lite v1.3.3 */
export const DF_LAT_LITE_FILENAME_V1_3_3 = "Setup DF LAT Lite 1.3.3.exe";
export const DF_LAT_LITE_V1_3_3 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Lite%201.3.3.exe";

/* DF LAT Pro v1.3.2 */
export const DF_LAT_PRO_FILENAME_V1_3_2 = "Setup DF LAT Pro 1.3.2.exe";
export const DF_LAT_PRO_V1_3_2 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Pro%201.3.2.exe";

/* DF LAT Lite v1.3.2 */
export const DF_LAT_LITE_FILENAME_V1_3_2 = "Setup DF LAT Lite 1.3.2.exe";
export const DF_LAT_LITE_V1_3_2 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Lite%201.3.2.exe";

/* DF LAT Pro v1.3.1 */
export const DF_LAT_PRO_FILENAME_V1_3_1 = "Setup DF LAT Pro 1.3.1.exe";
export const DF_LAT_PRO_V1_3_1 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Pro%201.3.1.exe";

/* DF LAT Lite v1.3.1 */
export const DF_LAT_LITE_FILENAME_V1_3_1 = "Setup DF LAT Lite 1.3.1.exe";
export const DF_LAT_LITE_V1_3_1 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Lite%201.3.1.exe";

/* DF LAT Pro v1.3.0 */
export const DF_LAT_PRO_FILENAME_V1_3_0 = "Setup DF LAT Pro 1.3.0.exe";
export const DF_LAT_PRO_V1_3_0 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Pro%201.3.0.exe";

/* DF LAT Lite v1.3.0 */
export const DF_LAT_LITE_FILENAME_V1_3_0 = "Setup DF LAT Lite 1.3.0.exe";
export const DF_LAT_LITE_V1_3_0 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Lite%201.3.0.exe";

/* DF LAT Pro v1.2.0 */
export const DF_LAT_PRO_FILENAME_V1_2_0 = "Setup DF LAT Pro 1.2.0.exe";
export const DF_LAT_PRO_V1_2_0 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Pro%201.2.0.exe";

/* DF LAT Lite v1.2.0 */
export const DF_LAT_LITE_FILENAME_V1_2_0 = "Setup DF LAT Lite 1.2.0.exe";
export const DF_LAT_LITE_V1_2_0 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Lite%201.2.0.exe";

/* DF LAT Pro v1.1.0 */
export const DF_LAT_PRO_FILENAME_V1_1_0 = "Setup DF LAT Pro 1.1.0.exe";
export const DF_LAT_PRO_V1_1_0 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Pro%201.1.0.exe";

/* DF LAT Lite v1.1.0 */
export const DF_LAT_LITE_FILENAME_V1_1_0 = "Setup DF LAT Lite 1.1.0.exe";
export const DF_LAT_LITE_V1_1_0 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Lite%201.1.0.exe";

/* DF LAT Pro v1.0.1 */
export const DF_LAT_PRO_FILENAME_V1_0_1 = "Setup DF LAT Pro 1.0.1.exe";
export const DF_LAT_PRO_V1_0_1 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Pro%201.0.1.exe";

/* DF LAT Lite v1.0.1 */
export const DF_LAT_LITE_FILENAME_V1_0_1 = "Setup DF LAT Lite 1.0.1.exe";
export const DF_LAT_LITE_V1_0_1 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Lite%201.0.1.exe";

/* DF LAT Pro v1.0.0 */
export const DF_LAT_PRO_FILENAME_V1_0_0 = "Setup DF LAT Pro 1.0.0.exe";
export const DF_LAT_PRO_V1_0_0 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Pro%201.0.0.exe";

/* DF LAT Lite v1.0.0 */
export const DF_LAT_LITE_FILENAME_V1_0_0 = "Setup DF LAT Lite 1.0.0.exe";
export const DF_LAT_LITE_V1_0_0 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%20Lite%201.0.0.exe";

/* DF LAT v1.0.4 */
export const DF_LAT_FILENAME_V1_0_4 = "Setup DF LAT 1.0.4.exe";
export const DF_LAT_V1_0_4 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%201.0.4.exe";

/* DF LAT v1.0.3 */
export const DF_LAT_FILENAME_V1_0_3 = "Setup DF LAT 1.0.3.exe";
export const DF_LAT_V1_0_3 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%201.0.3.exe";

/* DF LAT v1.0.2 */
export const DF_LAT_FILENAME_V1_0_2 = "Setup DF LAT 1.0.2.exe";
export const DF_LAT_V1_0_2 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%201.0.2.exe";

/* DF LAT v1.0.0 */
export const DF_LAT_FILENAME_V1_0_0 = "Setup DF LAT 1.0.0.exe";
export const DF_LAT_V1_0_0 = "https://deepforestlicense.com/DFLAT/Setup%20DF%20LAT%201.0.0.exe";

/************************************/
/* DF BIRD v1.7.0 */
export const DF_BIRD_FILENAME_V1_7_0 = "Setup DF BIRD 1.7.0.exe";
export const DF_BIRD_URL_V1_7_0 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.7.0.exe";

/* DF BIRD v1.6.2 */
export const DF_BIRD_FILENAME_V1_6_2 = "Setup DF BIRD 1.6.2.exe";
export const DF_BIRD_URL_V1_6_2 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.6.2.exe";

/* DF BIRD v1.6.1 */
export const DF_BIRD_FILENAME_V1_6_1 = "Setup DF BIRD 1.6.1.exe";
export const DF_BIRD_URL_V1_6_1 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.6.1.exe";

/* DF BIRD v1.6.0 */
export const DF_BIRD_FILENAME_V1_6_0 = "Setup DF BIRD 1.6.0.exe";
export const DF_BIRD_URL_V1_6_0 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.6.0.exe";

/* DF BIRD v1.5.2 */
export const DF_BIRD_FILENAME_V1_5_2 = "Setup DF BIRD 1.5.2.exe";
export const DF_BIRD_URL_V1_5_2 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.5.2.exe";

/* DF BIRD v1.5.1 */
export const DF_BIRD_FILENAME_V1_5_1 = "Setup DF BIRD 1.5.1.exe";
export const DF_BIRD_URL_V1_5_1 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.5.1.exe";

/* DF BIRD v1.5.0 */
export const DF_BIRD_FILENAME_V1_5_0 = "Setup DF BIRD 1.5.0.exe";
export const DF_BIRD_URL_V1_5_0 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.5.0.exe";

/* DF BIRD v1.4.1 */
export const DF_BIRD_FILENAME_V1_4_1 = "Setup DF BIRD 1.4.1.exe";
export const DF_BIRD_URL_V1_4_1 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.4.1.exe";

/* DF BIRD v1.4.0 */
export const DF_BIRD_FILENAME_V1_4_0 = "Setup DF BIRD 1.4.0.exe";
export const DF_BIRD_URL_V1_4_0 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.4.0.exe";

/* DF BIRD v1.3.0 */
export const DF_BIRD_FILENAME_V1_3_0 = "Setup DF BIRD 1.3.0.exe";
export const DF_BIRD_URL_V1_3_0 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.3.0.exe";

/* DF BIRD v1.2.0 */
export const DF_BIRD_FILENAME_V1_2_0 = "Setup DF BIRD 1.2.0.exe";
export const DF_BIRD_URL_V1_2_0 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.2.0.exe";

/* DF BIRD v1.1.0 */
export const DF_BIRD_FILENAME_V1_1_0 = "Setup DF BIRD 1.1.0.exe";
export const DF_BIRD_URL_V1_1_0 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.1.0.exe";

/* DF BIRD v1.0.3 */
export const DF_BIRD_FILENAME_V1_0_3 = "Setup DF BIRD 1.0.3.exe";
export const DF_BIRD_URL_V1_0_3 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.0.3.exe";

/* DF BIRD v1.0.2 */
export const DF_BIRD_FILENAME_V1_0_2 = "Setup DF BIRD 1.0.2.exe";
export const DF_BIRD_URL_V1_0_2 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.0.2.exe";

/* DF BIRD v1.0.1 */
export const DF_BIRD_FILENAME_V1_0_1 = "Setup DF BIRD 1.0.1.exe";
export const DF_BIRD_URL_V1_0_1 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.0.1.exe";

/* DF BIRD v1.0.0 */
export const DF_BIRD_FILENAME_V1_0_0 = "Setup DF BIRD 1.0.0.exe";
export const DF_BIRD_URL_V1_0_0 = "https://deepforestlicense.com/DFBIRD/Setup%20DF%20BIRD%201.0.0.exe";

/************************************/
/* DF Scanner Pro latest */
// DF Scanner Pro version ファイル名
export const DF_SCANNER_PRO_FILENAME = DF_SCANNER_PRO_FILENAME_V1_9_2;
// DF Scanner Pro version ダウンロードURL
export const DF_SCANNER_PRO_URL = DF_SCANNER_PRO_URL_V1_9_2;

// AI樹冠分離モデル ファイル名
export const AI_SEGMENTATION_MODEL_FILENAME = AI_SEGMENTATION_MODEL_FILENAME_V1_0;
// AI樹冠分離モデル ダウンロードURL
export const AI_SEGMENTATION_MODEL_URL = AI_SEGMENTATION_MODEL_URL_V1_0;

/************************************/
/* DF Scanner Lite latest */
// DF Scanner Lite version ファイル名
export const DF_SCANNER_LITE_FILENAME = DF_SCANNER_LITE_FILENAME_V1_9_0;
// DF Scanner Lite version ダウンロードURL
export const DF_SCANNER_LITE_URL = DF_SCANNER_LITE_URL_V1_9_0;

/************************************/
/* DF Scanner latest */
// DF Scanner version ファイル名
export const DF_SCANNER_FILENAME = DF_SCANNER_FILENAME_V1_8_2;
// DF Scanner version ダウンロードURL
export const DF_SCANNER_URL = DF_SCANNER_URL_V1_8_2;

/************************************/
/* DF LAT Pro latest */
// DF LAT Pro ファイル名
export const DF_LAT_PRO_FILENAME = DF_LAT_PRO_FILENAME_V2_0_0;
// DF LAT Pro ダウンロードURL
export const DF_LAT_PRO_URL = DF_LAT_PRO_V2_0_0;

/************************************/
/* DF LAT Lite latest */
// DF LAT Lite ファイル名
export const DF_LAT_LITE_FILENAME = DF_LAT_LITE_FILENAME_V2_0_0;
// DF LAT Lite ダウンロードURL
export const DF_LAT_LITE_URL = DF_LAT_LITE_V2_0_0;

/************************************/
/* DF Viewer latest */
// DF Viewer ファイル名
export const DF_VIEWER_FILENAME = DF_VIEWER_FILENAME_V1_4_1;
// DF Viewer ダウンロードURL
export const DF_VIEWER_URL = DF_VIEWER_URL_V1_4_1;

/************************************/
/* DF BIRD latest */
// DF BIRD ファイル名
export const DF_BIRD_FILENAME = DF_BIRD_FILENAME_V1_7_0;
// DF BIRD ダウンロードURL
export const DF_BIRD_URL = DF_BIRD_URL_V1_7_0;

/************************************/
// [日本語]ドローン計測諸元 ファイル名
export const RECOMMENDED_UAV_FLIGHT_FILENAME_JA = "日本語";
// [日本語]ドローン計測諸元 ダウンロードURL
export const RECOMMENDED_UAV_FLIGHT_URL_JA =
    "https://deepforestlicense.com/DFScanner/docs/df-measurement-specifications-ja.pdf";
// [英語]ドローン計測諸元 ファイル名
export const RECOMMENDED_UAV_FLIGHT_FILENAME_EN = "English";
// [英語]ドローン計測諸元 ダウンロードURL
export const RECOMMENDED_UAV_FLIGHT_URL_EN =
    "https://deepforestlicense.com/DFScanner/docs/df-measurement-specifications-en.pdf";

/************************************/
// DF Scanner テストデータ ファイル名
export const DF_SCANNER_TESTDATA_FILENAME = "Test_Data.zip";
// DF Scanner テストデータ ダウンロードURL
export const DF_SCANNER_TESTDATA_URL = "https://deepforestlicense.com/DFScanner/Test_Data.zip";

/************************************/
// DF Scanner Pro ユーザーマニュアル
export const DF_SCANNER_PRO_MANUAL_JA_FILENAME = "DF Scanner Pro 使用説明書 1.9.pdf";
export const DF_SCANNER_PRO_MANUAL_JA_URL =
    "https://deepforestlicense.com/DFScanner/docs/1.9/DF Scanner Pro 使用説明書 1.9.pdf";
export const DF_SCANNER_PRO_MANUAL_EN_FILENAME = "DF Scanner Pro User's Guide 1.9.pdf";
export const DF_SCANNER_PRO_MANUAL_EN_URL =
    "https://deepforestlicense.com/DFScanner/docs/1.9/DF Scanner Pro User's Guide 1.9.pdf";

/************************************/
// DF Scanner Lite ユーザーマニュアル
export const DF_SCANNER_LITE_MANUAL_JA_FILENAME = "DF Scanner Lite 使用説明書 1.9.pdf";
export const DF_SCANNER_LITE_MANUAL_JA_URL =
    "https://deepforestlicense.com/DFScanner/docs/1.9/DF Scanner Lite 使用説明書 1.9.pdf";
export const DF_SCANNER_LITE_MANUAL_EN_FILENAME = "DF Scanner Lite User's Guide 1.9.pdf";
export const DF_SCANNER_LITE_MANUAL_EN_URL =
    "https://deepforestlicense.com/DFScanner/docs/1.9/DF Scanner Lite User's Guide 1.9.pdf";

/************************************/
// DF LAT PRO ユーザーマニュアル
export const DF_LAT_PRO_MANUAL_JA_FILENAME = "DF LAT Pro 使用説明書2.0.pdf";
export const DF_LAT_PRO_MANUAL_JA_URL = "https://deepforestlicense.com/DFLAT/docs/DF LAT Pro 使用説明書2.0.pdf";
export const DF_LAT_PRO_MANUAL_EN_FILENAME = "DF LAT Pro User's Guide2.0.pdf";
export const DF_LAT_PRO_MANUAL_EN_URL = "https://deepforestlicense.com/DFLAT/docs/DF LAT Pro User's Guide2.0.pdf";

export const DF_LAT_PRO_MANUAL_JA_FILENAME_V1 = "DF LAT Pro 使用説明書1.3.pdf";
export const DF_LAT_PRO_MANUAL_JA_URL_V1 = "https://deepforestlicense.com/DFLAT/docs/DF LAT Pro 使用説明書1.3.pdf";
export const DF_LAT_PRO_MANUAL_EN_FILENAME_V1 = "DF LAT Pro User's Guide1.3.pdf";
export const DF_LAT_PRO_MANUAL_EN_URL_V1 = "https://deepforestlicense.com/DFLAT/docs/DF LAT Pro User's Guide1.3.pdf";
/************************************/
// DF LAT LITE ユーザーマニュアル
export const DF_LAT_LITE_MANUAL_JA_FILENAME = "DF LAT Lite 使用説明書2.0.pdf";
export const DF_LAT_LITE_MANUAL_JA_URL = "https://deepforestlicense.com/DFLAT/docs/DF LAT Lite 使用説明書2.0.pdf";
export const DF_LAT_LITE_MANUAL_EN_FILENAME = "DF LAT Lite User's Guide2.0.pdf";
export const DF_LAT_LITE_MANUAL_EN_URL = "https://deepforestlicense.com/DFLAT/docs/DF LAT Lite User's Guide2.0.pdf";

export const DF_LAT_LITE_MANUAL_JA_FILENAME_V1 = "DF LAT Lite 使用説明書1.3.pdf";
export const DF_LAT_LITE_MANUAL_JA_URL_V1 = "https://deepforestlicense.com/DFLAT/docs/DF LAT Lite 使用説明書1.3.pdf";
export const DF_LAT_LITE_MANUAL_EN_FILENAME_V1 = "DF LAT Lite User's Guide1.3.pdf";
export const DF_LAT_LITE_MANUAL_EN_URL_V1 = "https://deepforestlicense.com/DFLAT/docs/DF LAT Lite User's Guide1.3.pdf";
/************************************/
// DF Viewer ユーザーマニュアル
export const DF_VIEWER_MANUAL_JA_FILENAME = "DF Viewer 簡単操作マニュアル.pdf";
export const DF_VIEWER_MANUAL_JA_URL = "https://deepforestlicense.com/DFViewer/DF-Viewer-Users-Guide.pdf";

/************************************/
// DF BIRD ユーザーマニュアル
export const DF_BIRD_MANUAL_JA_FILENAME = "DF BIRD 使用説明書.pdf";
export const DF_BIRD_MANUAL_JA_URL =
    "https://deepforestlicense.com/DFBIRD/docs/DF%20BIRD%20%E4%BD%BF%E7%94%A8%E8%AA%AC%E6%98%8E%E6%9B%B81.7.pdf";
export const DF_BIRD_MANUAL_EN_FILENAME = "DF BIRD User's Guide.pdf";
export const DF_BIRD_MANUAL_EN_URL = "https://deepforestlicense.com/DFBIRD/docs/DF%20BIRD%20User%27s%20Guide1.7.pdf";

/************************************/
// DF Walker Google Playストア リンク
export const DF_WALKER_GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=com.jp.dfwalker&hl=ja";
// DF Walker App Store　リンク
export const DF_WALKER_APP_STORE_LINK = "https://apps.apple.com/jp/app/df-walker/id6739127226";

/************************************/
// DF Walker ユーザーマニュアル
export const DF_WALKER_ANDROID_MANUAL_JA_URL = "https://deepforestlicense.com/DFWalker/docs/usermanual.pdf";
export const DF_WALKER_ANDROID_MANUAL_EN_URL = "https://deepforestlicense.com/DFWalker/docs/usermanual-en.pdf";
export const DF_WALKER_IOS_MANUAL_JA_URL = "https://deepforestlicense.com/DFWalker/docs/usermanual-ios.pdf";
export const DF_WALKER_IOS_MANUAL_EN_URL = "https://deepforestlicense.com/DFWalker/docs/usermanual-ios-en.pdf";

/************************************/
// DF Scanner 利用規約
export const DF_SCANNER_PRO_TERMS_OF_USE_JA_URL =
    "https://deepforestlicense.com/DFScanner/docs/df-scanner-pro-terms-of-use-ja.pdf";
export const DF_SCANNER_PRO_TERMS_OF_USE_EN_URL =
    "https://deepforestlicense.com/DFScanner/docs/df-scanner-pro-terms-of-use-en.pdf";
export const DF_SCANNER_LITE_TERMS_OF_USE_JA_URL =
    "https://deepforestlicense.com/DFScanner/docs/df-scanner-lite-terms-of-use-ja.pdf";
export const DF_SCANNER_LITE_TERMS_OF_USE_EN_URL =
    "https://deepforestlicense.com/DFScanner/docs/df-scanner-lite-terms-of-use-en.pdf";

/************************************/
// DF LAT 利用規約
export const DF_LAT_PRO_TERMS_OF_USE_JA_URL = "https://deepforestlicense.com/DFLAT/docs/df-lat-pro-terms-of-use-ja.pdf";
export const DF_LAT_PRO_TERMS_OF_USE_EN_URL = "https://deepforestlicense.com/DFLAT/docs/df-lat-pro-terms-of-use-en.pdf";
export const DF_LAT_LITE_TERMS_OF_USE_JA_URL =
    "https://deepforestlicense.com/DFLAT/docs/df-lat-lite-terms-of-use-ja.pdf";
export const DF_LAT_LITE_TERMS_OF_USE_EN_URL =
    "https://deepforestlicense.com/DFLAT/docs/df-lat-lite-terms-of-use-en.pdf";

/************************************/
// DF BIRD 使用許諾
export const DF_BIRD_LICENSE_URL = "https://deepforestlicense.com/DFBIRD/docs/df-bird-license.pdf";

/************************************/
// DF Viewer 利用規約
export const DF_VIEWER_TERMS_OF_USE_JA_URL =
    "https://deepforestlicense.com/DFViewer/docs/df-viewer-terms-of-use-ja.pdf";
export const DF_VIEWER_TERMS_OF_USE_EN_URL =
    "https://deepforestlicense.com/DFViewer/docs/df-viewer-terms-of-use-en.pdf";
